// extracted by mini-css-extract-plugin
export default {"container":"XX-z","title":"YX-z","link":"ZX-z"};